import IntroTemplate from '@shared/components/IntroTemplate'
import GameTemplate from '@shared/components/GameTemplate'
import OutroTemplate from '@shared/components/OutroTemplate'
import scrollHelper from '@shared/utils/scrollHelper'

const stepMixin = {
  components: {
    IntroTemplate,
    GameTemplate,
    OutroTemplate
  },
  methods: {
    next () {
      this.$store.dispatch('next')
    },
    navigateTo (step) {
      this.$store.dispatch('navigate', step)
    },
    exit () {
      this.$store.dispatch('exit')
    }
  },
  mounted () {
    this.$store.dispatch('save')
    scrollHelper.scrollToTop()
    setTimeout(() => {
      scrollHelper.showArrow()
    }, 1000)
  }
}

export default stepMixin
